import { z } from "zod";
export const DTOCodeSnapshotScannerType = z.enum(["Components", "Usage"]);
export const DTOCodeSnapshotUploadInitResponse = z.object({
    fileId: z.string(),
    snapshotId: z.string(),
    uploadUrl: z.string(),
});
export const DTOCodeSnapshotProcessingRunResponse = z.object({
    processingRunId: z.string(),
    snapshotIds: z.array(z.string()),
});
export const DTOCodeSnapshotFinalizeResponse = z.object({
    ok: z.literal(true),
    processingRunId: z.string().nullable(),
    snapshotId: z.string(),
});
export const DTOCodeSnapshotProcessingRunStatus = z.enum([
    "Processing",
    "Processed",
    "Failed",
]);
export const DTOCodeSnapshotProcessingRunStatusItem = z.object({
    createdAt: z.string(),
    errorSummary: z.string().nullable(),
    failedComponentsCount: z.number(),
    finishedAt: z.string().nullable(),
    processingRunId: z.string(),
    snapshotIds: z.array(z.string()),
    startedAt: z.string(),
    status: DTOCodeSnapshotProcessingRunStatus,
    updatedAt: z.string(),
});
export const DTOCodeSnapshotProcessingRunStatusResponse = z.object({
    runs: z.array(DTOCodeSnapshotProcessingRunStatusItem),
});
